/**
 * Save text as a file through the browser's download, named `fileName`.
 *
 * The one copy of the Blob-and-link routine: Reports and CRM Enrich each had
 * their own. The link is attached to the page while it is clicked (Firefox
 * ignores a click on a detached link), and its object URL is released on the
 * next tick, because revoking it in the same tick can cancel the download in
 * Safari and Firefox.
 *
 * Args:
 *     content: the file's text.
 *     fileName: the name the browser saves it under.
 *     type: its MIME type, e.g. 'text/csv;charset=utf-8'.
 */
export const downloadFile = (content, fileName, type) => {
    const url = URL.createObjectURL(new Blob([content], { type }))
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    setTimeout(() => URL.revokeObjectURL(url), 0)
}
